import { fabric } from "fabric"
import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import PathObject from "@/signomatic/app/objects/path"
import RectObject from "@/signomatic/app/objects/rect"

export default class FlagMountFixmethod extends BaseFixmethod {
  private get param() {
    return {
      width: Calc.mmToPx(27),
      height: Calc.mmToPx(17),
      bite: Calc.mmToPx(13.8),
      fillOffsetX: Calc.mmToPx(12),
      fillOffsetY: Calc.mmToPx(0.2),
    }
  }

  get externalLeftPadding(): number {
    return this.param.width - this.param.bite
  }

  topDrawable() {
    const { widthPx, heightPx, height } = this.state
    const items: fabric.Object[] = []
    const flipped = ["arrow_left", "direction_left"].includes(this.state.shape)
    const left = flipped ? widthPx * 1.5 : -widthPx / 2

    if (height > 99) {
      const top = this.mountGroup()
      top.set({
        left: left,
        top: heightPx * 0.25,
      })
      items.push(top)

      const bottom = this.mountGroup()
      bottom.set({
        left: left,
        top: heightPx * 0.75,
      })
      items.push(bottom)
    }

    if (height < 100 || height > 299) {
      const middle = this.mountGroup()
      middle.set({
        left: left,
        top: heightPx / 2,
      })
      items.push(middle)
    }

    items.push(
      new RectObject({
        fill: "transparent",
        width: this.param.bite * 2,
        height: heightPx,
        left: widthPx / 2,
      }).addClass("stretch")
    )

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }

  autoSizePadding() {
    return this.param.width
  }

  mountGroup() {
    const flipped = ["arrow_left", "direction_left"].includes(this.state.shape)
    const base = new PathObject(
      "M89.53,2.75V2.54H46.6V.5H12.94C9.27.5,6.08,4.75,3.88,11.64c-4.51,14.05-4.51,36.67,0,50.72,2.2,6.89,5.39,11.14,9.06,11.14H89.53V71.26c-2.4-.45-4.68-4-6.45-9.55-4.36-13.59-4.36-35.81,0-49.41C84.84,6.76,87.12,3.2,89.53,2.75Z",
      {
        originX: "center",
        originY: "center",
        left: 0,
        top: 0,
        scaleX: 1.16,
        scaleY: 0.87,
      }
    ).addClass("hang", "preview")

    base.set(
      "fill",
      new fabric.Gradient({
        coords: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: base.height,
        },
        colorStops: [
          { offset: 0, color: "#cbcbcb" },
          { offset: 0.47, color: "#e4e4e4" },
          { offset: 1, color: "#9b9b9b" },
        ],
      })
    )

    const baseFill = new PathObject("M88.94,2.54C83.29,5.44,79,20,79,37.5c0,18.14,4.6,33.08,10.53,35.22V2.54Z", {
      originX: "center",
      originY: "center",
      left: flipped ? 0 - this.param.fillOffsetX : 0 + this.param.fillOffsetX,
      top: this.param.fillOffsetY,
      fill: "#d8d8d8",
      scaleX: 1.16,
      scaleY: 0.87,
    }).addClass("preview")

    if (flipped) {
      base.rotate(180)
      baseFill.rotate(180)
    }

    return new fabric.Group([baseFill, base], {
      originY: "center",
      left: 0,
      top: 0,
      width: this.param.width,
      height: this.param.height,
    })
  }
}
